import { format as formatDate } from 'date-fns-tz';
import { DATE_FNS_FORMAT_STR_REGEX, lookupDateFNLocale } from 'i18n/date-fns';
import { i18nInstance } from 'i18n/index';
import { NUMERAL_FORMAT_STR_REGEX, setNumeralLocale } from 'i18n/numeral';
import { FormatFunction } from 'i18next';
import numeral from 'numeral';

const Z_PATTERN = /[zZ]/g;

// See https://www.i18next.com/translation-function/formatting
export const formatter: FormatFunction = (value, format= '', lng = i18nInstance.language) => {
  if (value === undefined || value === null) return value;

  // Use Date-fns
  if (format && DATE_FNS_FORMAT_STR_REGEX.test(format)) {
    const isLocalTimeZone = value instanceof Date && value.getTimezoneOffset() === (new Date()).getTimezoneOffset();

    return formatDate(value, (isLocalTimeZone ? format.replace(Z_PATTERN, '') : format).trim(), {
      locale: lookupDateFNLocale(lng),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
  }

  // Use Numeral.js
  if (format && NUMERAL_FORMAT_STR_REGEX.test(format)) {
    const initialLocale = numeral.locale();
    setNumeralLocale(lng);
    try {
      return numeral(value).format(format);
    } finally {
      numeral.locale(initialLocale);
    }
  }

  // If we have a format string but don't recognize it
  if (format) {
    console.error(`Unrecognized i18n interpolation format '${format}'.\nSee https://date-fns.org/v2.12.0/docs/format and http://numeraljs.com/ for valid format strings.`);
  }

  return value;
};
